<div class="snippet-container">
	<ng-container *ngIf="!editMode">
		<div [ngClass]="[snippet.paddingH, snippet.paddingV, snippet.backgroundColour]" [innerHTML]="snippet.content"></div>
		<div class="text-end mt-2">
			<button class="btn btn-sm btn-primary" (click)="editSnippet()">Edit</button>
			<button class="btn btn-sm btn-danger ms-2" (click)="deleteConfirm()">Remove</button>
			<button class="btn btn-sm btn-primary ms-2" (click)="edit()">Edit</button>
		</div>
	</ng-container>

	<ng-container *ngIf="editMode">
		<div class="m-3">
            <editor
            #editorElement
            elementId="editor-element"
            [(ngModel)]="snippet.content"
            [apiKey]="this.env.tinymceApiKey"
            [init]="tinyInit"></editor>

		</div>
		<div class="text-end mt-2">
            <button class="btn btn-sm btn-primary ms-2" *ngIf="!snippet.backgroundImage" (click)="backgroundImage(snippet)">Background image</button>
            <button class="btn btn-sm btn-primary ms-2" *ngIf="snippet.backgroundImage" (click)="snippet.backgroundImage = ''">Remove background image</button>

            <button class="btn btn-sm btn-primary ms-2" (click)="addButton()">Add button</button>
            <button class="btn btn-sm btn-primary ms-2" (click)="cancel()">Cancel</button>
			<button class="btn btn-sm btn-primary ms-2" (click)="save()">Save</button>
		</div>
	</ng-container>

</div>
<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>

<app-snippet-edit [snippet]="snippet" (modalAction)="editModalAction($event)" *ngIf="snippetEditModal"></app-snippet-edit>

